import axios from 'axios';

const VERSION_CHECK_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes
let currentVersion = null;

export const initVersionCheck = () => {
  // Initial version check
  checkVersion();

  // Set up periodic version check
  setInterval(checkVersion, VERSION_CHECK_INTERVAL);
};

const checkVersion = async () => {
  try {
    const response = await axios.get('/version.json', {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
    
    const newVersion = response.data.version;
    
    if (currentVersion === null) {
      // First load, just store the version
      currentVersion = newVersion;
    } else if (currentVersion !== newVersion) {
      // Version has changed, reload the page
      currentVersion = newVersion;
      window.location.reload(true);
    }
  } catch (error) {
    console.error('Error checking version:', error);
  }
}; 